export default __webpack_public_path__ + "static/media/placeholder_private01-jp-mobile.987e8e79.png";